import { LitElement, html, css } from 'lit'

class FilterSearchBox extends LitElement {
  #listContainer
  #searchResult

  static styles = css``

  constructor() {
    super()
    this.searchPageHero = document.querySelector('.searchpage-hero')
    this.inputField = document.getElementById('input-search')
    this.clearButton = document.querySelector('.button-clear')
    this.searchButton = document.querySelector('.button-search')
    this.form = document.querySelector('form')
    this.detectKeyboardNav()
  }

  static properties = {
    for: {},
    using: {},
  }

  connectedCallback() {
    super.connectedCallback()

    this.inputField.addEventListener('input', (e) => {
      this.valueOnChange(e)
    })

    this.clearButton.addEventListener('click', (e) => {
      this.clearInputValue(e)
    })
    this.clearButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.clearInputValue(e)
      }
    })

    window.addEventListener('popstate', (e) => {
      let urlWithoutQueryParams =
        window.location.origin + window.location.pathname

      window.history.pushState({}, '', urlWithoutQueryParams)

      this.clearInputValue(e)
    })

    this.searchButton.addEventListener('click', this.searchFunction)

    this.inputField.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.searchFunction(e)
      }
    })
  }

  searchFunction = async (e) => {
    e.preventDefault()
    if (this.inputField.value === '') {
      this.inputField.focus()
      return
    }

    const url = this.createUrlSearch(this.inputField.value)
    window.history.pushState({}, '', url)

    await this.search(this.inputField.value)

    this.checkInputValue()
  }

  firstUpdated() {
    this.#listContainer = document.getElementById(this.for)
    this.#searchResult = document.getElementById(this.for)
  }

  syncParamsWithSearchResult(value) {
    this.#listContainer.dispatchEvent(
      new CustomEvent('search-result', { bubbles: true, detail: value })
    )

    this.#searchResult.dispatchEvent(
      new CustomEvent('search-result', { bubbles: true, detail: value })
    )
  }

  detectKeyboardNav() {
    this.inputField.addEventListener('click', () => {
      this.inputField.classList.add('hide-focusstate')
    })

    this.inputField.addEventListener('keydown', (event) => {
      if (event.key == 'Tab') {
        this.inputField.classList.remove('hide-focusstate')
      }
    })
  }

  createUrlSearch(value) {
    let searchParams = new URLSearchParams(window.location.search)
    const currentlySelectedFilter = document.querySelector(
      "[aria-selected='true']"
    )
    const filterCategory = document.querySelector('filter-group').name
    const filterSearchName = document.querySelector('#input-search').name

    const searchQuery = currentlySelectedFilter.value

    searchParams.set(filterCategory, searchQuery)
    searchParams.set(filterSearchName, value)

    searchParams.delete('p')
    let url = new URL(window.location.href)
    url.search = searchParams.toString()
    return url
  }

  valueOnChange(e) {
    const currentValue = e.currentTarget.value.trim()

    if (currentValue !== this.previousValue) {
      this.searchButton.style.display = 'flex'
      this.clearButton.style.display = 'none'
    }
    this.previousValue = currentValue
  }

  updateUI(hasValue) {
    this.searchButton.style.display = hasValue ? 'none' : 'flex'
    this.clearButton.style.display = hasValue ? 'flex' : 'none'
  }

  checkInputValue() {
    const hasValue = this.inputField.value.trim() !== ''
    this.searchPageHero.classList.add('searchpage-hero--active')
    this.updateUI(hasValue)
  }

  clearInputValue(e) {
    e.preventDefault()
    let queryParams = window.location.search
    if (queryParams === '') {
      this.inputField.value = ''
      this.searchPageHero.classList.remove('searchpage-hero--active')
      this.updateUI(false)
    }
    this.inputField.value = ''
    this.updateUI(false)
  }

  async syncParamsWithSearchResult(query) {
    const url = new URL(this.dataset.fetchUrl, window.location.origin)
    url.searchParams.append('q', query)

    const response = await fetch(url.pathname + url.search)

    if (!response.ok) return
  }

  async search(query) {
    const url = new URL(this.dataset.fetchUrl, window.location.origin)
    url.searchParams.append('q', query)

    this.form.setAttribute('aria-busy', 'true')
    this.searchButton.setAttribute('aria-busy', 'true')

    await fetch(url.pathname + url.search)
      .then((response) => {
        return response.text()
      })
      .then((result) => {
        document.getElementById(this.for).dispatchEvent(
          new CustomEvent('search-result-update', {
            bubbles: true,
            detail: {
              body: result,
              searchValue: query,
            },
          })
        )
      })
      .finally(() => {
        this.form.removeAttribute('aria-busy')
        this.searchButton.removeAttribute('aria-busy')
      })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('filter-search-box', FilterSearchBox)
